import React from 'react';
import { TextArea } from 'semantic-ui-react';

export default TextArea;
